export default __webpack_public_path__ + "ebba33d991b28edbed4f364a0cca98c9.ttf";